import { useQuery } from '@tanstack/react-query';
import { get } from '../api/client.js';

const KEY = (from, to) => ['geofence-violations', from, to];

export function useGeofenceViolations({ from, to } = {}) {
  const qs = new URLSearchParams();
  if (from) qs.set('from', String(from));
  if (to)   qs.set('to',   String(to));
  return useQuery({
    queryKey: KEY(from, to),
    queryFn: async () => (await get(`/api/admin/geofence-violations?${qs.toString()}`)).violations || [],
    staleTime: 15_000,
  });
}
